import React from 'react';

const FullStack = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">FullStack developer</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">HTML</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">CSS</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">Javascript</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">ReactJs</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>
                </div>

                <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">Java</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">SQL</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">MongoDB</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">Git</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>
                </div>
        </div>
    </div>
  );
};

export default FullStack;